import Vue from "vue";
import Vuex from "vuex";
import VuexI18n from "vuex-i18n";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    productCard: 0,
    itemsCards: [],
    dataUser: [],
    userRole: "",
  },
  getters: {
    dataUser(state) {
      console.log(state);
      return state.dataUser;
    },
    productCard(state) {
      return state.productCard;
    },
    itemsCards(state) {
      return state.itemsCards;
    }
  },
  mutations: {
    setUserRole(state, value) {
      state.userRole = value;
    },
    addCard(state, data) {
      state.productCard += data.quantity;
      state.itemsCards.push(data.item);
    },
    totalPoints(state, data) {
      state.productCard = data;
    },
    removeCard(state, data) {
      // console.log("va a quitar un producto");
      console.log(data);
      state.productCard -= data;
      state.itemsCards.splice();
    }
    // removeCard(state, step) {
    //   console.log("Quiero quitar");
    //   console.log(step);
    // }
  },
  actions: {}
});

Vue.use(VuexI18n.plugin, store);

export default store;
